"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkState;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _immutableSetter = require("immutable-setter");
// Taken from: https://blog.rescale.com/addressing-valuelink-deprecation-in-react-15/

function createHandler(component, key, path) {
  return function (e) {
    var el = e.target;
    var value = el.type === 'checkbox' ? el.checked : el.value;
    component.setState((0, _defineProperty2["default"])({}, key, path ? (0, _immutableSetter.setIn)(component.state[key], path, value) : value), function () {
      if (typeof component.onLinkStateChange !== "undefined") {
        component.onLinkStateChange();
      }
    });
  };
}
function linkState(component, key, path) {
  if (path) {
    return createHandler(component, key, path);
  }
  var cache = component.__linkStateHandlers || (component.__linkStateHandlers = {});
  return cache[key] || (cache[key] = createHandler(component, key));
}